import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { DialogActions } from '@mui/material';
import GhostButton from '../button/GhostButton';
import PrimaryButton from '../button/PrimaryButton';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { BodyText, Subheading } from '../typography/PrimaryTypography';

/**
 * A global modal informing the user that they do not have access when trying to open a module link.
 * @param {boolean} open The display state of the modal.
 * @param {string} title The header text of the modal.
 * @param {string} description The additional descriptive to display.
 * @param {void} handleCloseModal Handler to close the modal.
 * @returns {JSX.Element}
 */
const ModuleAccessDeniedModal = ({
  open,
  title,
  description,
  handleCloseModal
}: {
  open: boolean;
  title: string;
  description: string;
  handleCloseModal: () => void;
}) => {
  const navigate: NavigateFunction = useNavigate();

  const handleNavigateContact = (): void => {
    navigate('/contact');
    handleCloseModal();
  };

  return (
    <Dialog open={open} onClose={handleCloseModal}>
      <Subheading weight="Bold" sx={{ m: 2 }}>
        {title}
      </Subheading>
      <DialogContent>
        <BodyText id="explainer">{description}</BodyText>
        <DialogActions sx={{ mt: 2 }}>
          <GhostButton dark onClick={handleCloseModal}>
            Back
          </GhostButton>
          <PrimaryButton
            onClick={() => {
              handleNavigateContact();
            }}
          >
            Contact Energy Partners
          </PrimaryButton>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ModuleAccessDeniedModal;
